import apiClient from './config';

export default {
  // Rechercher des prospects par nom (pour autocomplete signup)
  searchProspects(query) {
    return apiClient.get('/prospect/search', {
      params: { query }
    });
  },

  // Récupérer les détails d'un prospect
  getProspectById(id) {
    return apiClient.get(`/prospect/${id}`);
  },

  // Réclamer un prospect
  claimProspect(prospectId, contactInfo) {
    return apiClient.post('/prospect/claim', {
      prospectId,
      ...contactInfo
    });
  }
};
